import { HTMLProps, ReactNode } from 'react'
import styled, { css } from 'styled-components'

export const btnStyles = css`
	box-shadow: none;
	outline: none;
	border: none;
	padding: 0;
`
const BtnView = styled.button`
	${btnStyles}
`

export type BtnProps = Pick<
	HTMLProps<HTMLButtonElement>,
	'onClick' | 'disabled' | 'className' | 'title' | 'id' | 'aria-label' | 'style'
> & {
	type?: 'submit' | 'button'
	noDefault?: boolean
	children: ReactNode
}
export const Btn = ({
	children,
	className,
	onClick,
	noDefault = true,
	type,
	...props
}: BtnProps) => {
	return (
		<BtnView
			onClick={e => {
				if (noDefault) e.preventDefault()
				if (onClick) onClick(e)
			}}
			className={`btn${className ? ` ${className}` : ''}`}
			type={type}
			{...props}
		>
			{children}
		</BtnView>
	)
}
